module.exports = __webpack_public_path__ + "static/media/paddle-court.109038ae.webp";